import React from "react";
import "../../styles/index.less";

// Define props interface
interface LandingPageProps {
  onGetStarted: () => void; // Function that takes no arguments and returns void
}

const LandingPage: React.FC<LandingPageProps> = ({ onGetStarted }) => {
  return (
    <section className="homepage">
      <div className="homepage__overlay">
        <h1 className="homepage__heading">
          Shaping the Future of{" "}
          <span className="highlight">India’s REITs & InvITs</span> Ecosystem{" "}
        </h1>
        <p className="homepage__text">
          Discover comprehensive insights on participants, properties, and
          projects driving India’s Real Estate and Infrastructure growth.
        </p>
        <p className="homepage__subtext">
          Compare, evaluate, and become a wise investor
        </p>
        <button
          className="homepage__cta"
          onClick={onGetStarted} // Trigger parent state change
        >
          Get Started
        </button>
      </div>
    </section>
  );
};

export default LandingPage;
